/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;



import Vue from "vue";
import Vuetify from "../plugins/vuetify"
import VueRouter from "vue-router"
import { store } from "./store"

import VueSweetalert2 from 'vue-sweetalert2';


import "../plugins/vuetify-money";

import HomePage from "./components/pages/HomePage"
import SettingsPage from "./components/pages/SettingsPage"
import DocumentTypesPage from "./components/pages/DocumentTypesPage"
import ChargeTypesPage from "./components/pages/ChargeTypesPage"
import PackagesPage from "./components/pages/PackagesPage"
import VehiclesPage from "./components/pages/VehiclesPage"
import CompanyPage from "./components/pages/CompanyPage"
import CustomersPage from "./components/pages/CustomersPage"
import NewTransportationDocumentPage from "./components/pages/NewTransportationDocumentPage"
import TransportationDocumentsPage from "./components/pages/TransportationDocumentsPage"
import LedgersPage from "./components/pages/LedgersPage"
import PrimerPage from "./components/pages/PrimerPage.vue";

import NewIncomeDocumentPage from "./components/pages/NewIncomeDocumentPage"
import IncomeDocumentsPage from "./components/pages/IncomeDocumentsPage"
import EditTransportationDocumentPage from "./components/pages/EditTransportationDocumentPage"

import NewServiceDocumentPage from "./components/pages/NewServiceDocumentPage"
import ServiceDocumentsPage from "./components/pages/ServiceDocumentsPage"
import EditServiceDocumentPage from "./components/pages/EditServiceDocumentPage"

import ProductsPage from "./components/pages/ProductsPage"
import NewSalesDocumentPage from "./components/pages/NewSalesDocumentPage"
import SalesDocumentsPage from "./components/pages/SalesDocumentsPage"

import SalesPage from "./components/pages/SalesPage"
import ExportForTmsReportPage from "./components/pages/reports/ExportForTmsReportPage.vue";

import AccountLedgerPage from "./components/pages/AccountLedgerPage"


import 'sweetalert2/dist/sweetalert2.min.css';

import { localYmd } from "./utils/date";

Vue.use(VueRouter)
Vue.use(VueSweetalert2)
Vue.prototype.$localYmd = localYmd;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


Vue.component('app-container', require('./components/AppContainer.vue').default);
Vue.component('login-form', require('./components/LoginForm.vue').default);
Vue.component('file-uploader', require('./components/FileUploader.vue').default);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/home',
            name: 'home',
            component: HomePage
        },
        {
            path: '/settings',
            name: 'settings',
            component: SettingsPage
        },
        {
            path: '/document-types',
            name: 'documenttypes',
            component: DocumentTypesPage
        },
        {
            path: '/charge-types',
            name: 'chargetypes',
            component: ChargeTypesPage
        },
        {
            path: '/packages',
            name: 'packages',
            component: PackagesPage
        },
        {
            path: '/vehicles',
            name: 'vehicles',
            component: VehiclesPage
        },
        {
            path: '/company',
            name: 'company',
            component: CompanyPage
        },
        {
            path: '/customers',
            name: 'customers',
            component: CustomersPage
        },
        {
            path: '/documents/transportation/new',
            name: 'newtransportationdocument',
            component: NewTransportationDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/transportation/list',
            name: 'transportationdocuments',
            component: TransportationDocumentsPage
        },
        {
            path: '/documents/transportation/:id',
            name: 'edittransportationdocument',
            component: EditTransportationDocumentPage
        },
        {
            path: '/documents/income/new',
            name: 'newincomedocument',
            component: NewIncomeDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/income/list',
            name: 'incomedocuments',
            component: IncomeDocumentsPage
        },
        {
            path: '/accounts/ledgers',
            name: 'ledgers',
            component: LedgersPage
        },
        {
            path: '/ledgers',
            name : 'ledgers2',
            component: AccountLedgerPage
        },
        {
            path: '/documents/service/new',
            name: 'newservicedocument',
            component: NewServiceDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/service/list',
            name: 'servicedocuments',
            component: ServiceDocumentsPage
        },
        {
            path: '/documents/service/:id',
            name: 'editservicedocument',
            component: EditServiceDocumentPage
        },
        {
            path: '/documents/sales/new',
            name: 'newsalesdocument',
            component: NewSalesDocumentPage,
            meta: {
                noexpired: true
            }
        },
        {
            path: '/documents/sales/list',
            name: 'salesdocuments',
            component: SalesDocumentsPage
        },
        {
            path: '/products',
            name: 'products',
            component: ProductsPage
        },
        {
            path: '/sales',
            name: 'sales',
            component: SalesPage
        },
        {
            path: '/export/tms',
            name: 'export-for-tms',
            component: ExportForTmsReportPage
        },
        {
            path: '/primer',
            name: 'primer',
            component: PrimerPage
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.meta.noexpired) {

        let user = store.state.currentUser.user

        if (user.subscription_expired) {
            next({ name: 'home' })
        }
        else {
            next()
        }
    }
    else {
        next()
    }
})


const app = new Vue({
    el: '#app',
    vuetify: Vuetify,
    router,
    store,
});
